/* eslint-disable */

import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { post } from 'src/network/api'
import AppLoader from 'src/components/AppLoader'
import { ToastContainer, toast } from 'react-toastify'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CFormFeedback,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilArrowLeft, cilUser } from '@coreui/icons'


const ForgotPassword = () => {
  const [validated, setValidated] = useState(false)
  const [username, setUsername] = useState('')

 const [loading, setLoading] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const values = Object.fromEntries(formData.entries())
    console.log("Hostname:", username)
    // if (window.location.hostname.startsWith("admin")) {
    //   performAdminSignIn(values.username, values.password)
    //  }
    //  else
       if (window.location.hostname.startsWith("employee")) {
        performEmployeeSignIn(username)
     }
     
     else{
        performSignIn(username)
     }

    
  }
  async function performEmployeeSignIn(username,) {
  
  
      try {
          const data = await post('employee/forget-password', {
            username,
          })
           setLoading(false)
          toast.success('Instruction sent to registered email', { position: "bottom-center", autoClose: 3000 })
      } catch (e) {
        setLoading(false)
        toast.error(e?.toString(), { position: "bottom-center", autoClose: 3000 })
      }
    }

    async function performSignIn(username,) {
    
    
        try {
          setLoading(true)
          const data = await post('restaurant/forget-password', {
            username,
          })
           setLoading(false)
          toast.success('Instruction sent to registered email', { position: "bottom-center", autoClose: 3000 })
          // const userData = await post(`restaurant/get-restaurant-details/${data.restaurant._id}`)
          // userData.token = data.token
          // userData.role = process.env.REACT_APP_RESTAURANT_PREFIX
          // storeLoginData(userData)
          
          // navigate('/dashboard')
        } catch (e) {
          setLoading(false)
          toast.error(e?.toString(), { position: "bottom-center", autoClose: 3000 })
        }
      }

  return (
    <div className="bg-body-tertiary min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol lg={6} xl={5} sm={12}>
            <CCardGroup>
              <CCard className="p-lg-4">
                <CCardBody>
                  <CForm noValidate validated={validated} onSubmit={handleSubmit}>
                    <h1>Forgot Password</h1>
                    <p className="text-body-secondary">
                      Enter your username to reset your password.
                    </p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        type="text"
                        placeholder="Username"
                        autoComplete="username"
                        required
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                      <CFormFeedback invalid>Please enter a valid username.</CFormFeedback>
                    </CInputGroup>
                    <CRow>
                      <CCol xs={12} sm={6}>
                        <CButton type="submit" color="primary" className="px-4 text-white">
                          Forgot Password
                        </CButton>
                      </CCol>
                      <CCol xs={12} sm={6} className="text-right">
                        <Link to="/login">
                          <CButton color="link" className="px-0">
                            <CIcon icon={cilArrowLeft} /> Back to Login
                          </CButton>
                        </Link>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
      {loading && <AppLoader />}
      <ToastContainer />
    </div>
  )
}

export default ForgotPassword
